import React, {useContext, useEffect, useState} from 'react';
import Grid from "@mui/material/Grid2";
import {Box, Button, CircularProgress, LinearProgress, Paper, Tab, Tabs, TextField, Typography} from "@mui/material";
import SettingsTwoToneIcon from '@mui/icons-material/SettingsTwoTone';
import PropTypes from "prop-types";
import {useMutation, useQuery} from "@tanstack/react-query";
import {parametri, updateParametri} from "../apis/parametarApi";
import Notification from "../components/Notification";
import {LanguageContext} from "../components/LanguageContext";
import SaveTwoToneIcon from '@mui/icons-material/SaveTwoTone';
function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const SettingsPage = () => {
    const {translations} = useContext(LanguageContext);
    const [value, setValue] = useState(0);

    const [type, setType] = useState(null);
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");

    const [loading, setLoading] = useState(false);

    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
    };

    const {data, isLoading} = useQuery({
        queryKey: ['parametri'],
        queryFn: parametri
    });

    const mutation = useMutation({
        mutationFn: (formData) => updateParametri(formData),
        onSuccess: (response) => {
            setType(1);
            setMessage(response.data.message);
            setOpen(true);

            setLoading(false);
        },
        onError: (error) => {
            setType(2);
            setMessage(error.response.data.message);
            setOpen(true);

            setLoading(false);
        }
    });

    const [formData, setFormData] = useState({
        v: 0,
        ax: 0,
        ay: 0,
        az: 0,
        bx: 0,
        by: 0,
        bz: 0,
        cx: 0,
        cy: 0,
        cz: 0,
        trend_a: 0,
        trend_b: 0,
        trend_c: 0,
        lead_time: 0,
        monthly_order_time: 0,
        weekly_order_time: 0
    });

    useEffect(() => {
        if (data?.data) {
            setFormData({
                v: data?.data.v || 0,
                ax: data?.data.ax || 0,
                ay: data?.data.ay || 0,
                az: data?.data.az || 0,
                bx: data?.data.bx || 0,
                by: data?.data.by || 0,
                bz: data?.data.bz || 0,
                cx: data?.data.cx || 0,
                cy: data?.data.cy || 0,
                cz: data?.data.cz || 0,
                trend_a: data?.data.trend_a || 0,
                trend_b: data?.data.trend_b || 0,
                trend_c: data?.data.trend_c || 0,
                lead_time: data?.data.lead_time || 0,
                monthly_order_time: data?.data.monthly_order_time || 0,
                weekly_order_time: data?.data.weekly_order_time || 0
            });
        }
    }, [data]);

    const handleChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value});
    };

    const handleSave = (event) => {
        event.preventDefault();
        setLoading(true);
        mutation.mutateAsync(formData).catch((error) => {
        });
    };

    return (
        <Grid container spacing={2}>
            <Notification
                type={type}
                message={message}
                open={open}
                setOpen={setOpen}
            />
            <Grid size={{xs: 12}}>
                <Paper sx={{p: 2, justifyContent: "center", alignItems: "center"}}>
                    <Typography sx={{fontSize: 22, textAlign: "center"}}>
                        <SettingsTwoToneIcon size={22} sx={{mr: 2}}/>
                        {translations.settingsTitle}
                    </Typography>
                </Paper>
            </Grid>
            <Grid size={{xs: 12}}>
                <Paper sx={{p: 2, justifyContent: "center", alignItems: "center"}}>
                    <Box
                        sx={{ borderBottom: 1, borderColor: 'divider', height: 500 }}
                    >
                        <Tabs
                            variant="scrollable"
                            value={value}
                            onChange={handleChangeTab}
                            aria-label="Horizontal tabs for settings"
                            sx={{ borderRight: 1, borderColor: 'divider' }}
                        >
                            <Tab label={translations.settingsCoefficients} {...a11yProps(0)} />
                            <Tab label={translations.settingsTrends} {...a11yProps(1)} />
                            <Tab label={translations.settingsOther} {...a11yProps(2)} />
                        </Tabs>
                        <CustomTabPanel  value={value} index={0}>
                            {isLoading ? <LinearProgress size={24} color="inherit"/> : (
                                <Box sx={{
                                    height: 400,
                                    overflowY: 'scroll'
                                }}>
                                    <TextField
                                        fullWidth
                                        margin="dense"
                                        name="v"
                                        label={`${translations.settingsParameter} V`}
                                        variant="outlined"
                                        value={formData.v}
                                        onChange={handleChange}
                                    />
                                    <TextField
                                        fullWidth
                                        margin="dense"
                                        name="ax"
                                        label={`${translations.settingsParameter} AX`}
                                        variant="outlined"
                                        value={formData.ax}
                                        onChange={handleChange}
                                    />
                                    <TextField
                                        fullWidth
                                        margin="dense"
                                        name="ay"
                                        label={`${translations.settingsParameter} AY`}
                                        variant="outlined"
                                        value={formData.ay}
                                        onChange={handleChange}
                                    />
                                    <TextField
                                        fullWidth
                                        margin="dense"
                                        name="az"
                                        label={`${translations.settingsParameter} AZ`}
                                        variant="outlined"
                                        value={formData.az}
                                        onChange={handleChange}
                                    />

                                    <TextField
                                        fullWidth
                                        margin="dense"
                                        name="bx"
                                        label={`${translations.settingsParameter} BX`}
                                        variant="outlined"
                                        value={formData.bx}
                                        onChange={handleChange}
                                    />
                                    <TextField
                                        fullWidth
                                        margin="dense"
                                        name="by"
                                        label={`${translations.settingsParameter} BY`}
                                        variant="outlined"
                                        value={formData.by}
                                        onChange={handleChange}
                                    />
                                    <TextField
                                        fullWidth
                                        margin="dense"
                                        name="bz"
                                        label={`${translations.settingsParameter} BZ`}
                                        variant="outlined"
                                        value={formData.bz}
                                        onChange={handleChange}
                                    />

                                    <TextField
                                        fullWidth
                                        margin="dense"
                                        name="cx"
                                        label={`${translations.settingsParameter} CX`}
                                        variant="outlined"
                                        value={formData.cx}
                                        onChange={handleChange}
                                    />
                                    <TextField
                                        fullWidth
                                        margin="dense"
                                        name="cy"
                                        label={`${translations.settingsParameter} CY`}
                                        variant="outlined"
                                        value={formData.cy}
                                        onChange={handleChange}
                                    />
                                    <TextField
                                        fullWidth
                                        margin="dense"
                                        name="cz"
                                        label={`${translations.settingsParameter} CZ`}
                                        variant="outlined"
                                        value={formData.cz}
                                        onChange={handleChange}
                                    />
                                </Box>
                            )}
                        </CustomTabPanel >
                        <CustomTabPanel  value={value} index={1}>
                            {isLoading ? <LinearProgress /> : (
                                <Box sx={{
                                    height: 400,
                                    overflowY: 'scroll'
                                }}>
                                    <TextField
                                        fullWidth
                                        margin="dense"
                                        name="trend_a"
                                        label={`${translations.settingsTrend} A`}
                                        disabled={true}
                                        variant="outlined"
                                        value={formData.trend_a}
                                        onChange={handleChange}
                                    />
                                    <TextField
                                        fullWidth
                                        margin="dense"
                                        name="trend_b"
                                        label={`${translations.settingsTrend} B`}
                                        disabled={true}
                                        variant="outlined"
                                        value={formData.trend_b}
                                        onChange={handleChange}
                                    />
                                    <TextField
                                        fullWidth
                                        margin="dense"
                                        name="trend_c"
                                        label={`${translations.settingsTrend} C`}
                                        variant="outlined"
                                        disabled={true}
                                        value={formData.trend_c}
                                        onChange={handleChange}
                                    />
                                </Box>
                            )}
                        </CustomTabPanel >
                        <CustomTabPanel  value={value} index={2}>
                            {isLoading ? <LinearProgress /> : (
                                <Box sx={{
                                    height: 400,
                                    overflowY: 'scroll'
                                }}>
                                    <TextField
                                        fullWidth
                                        margin="dense"
                                        name="lead_time"
                                        label={translations.settingsLeadTime}
                                        variant="outlined"
                                        value={formData.lead_time}
                                        onChange={handleChange}
                                    />
                                    <TextField
                                        fullWidth
                                        margin="dense"
                                        name="monthly_order_time"
                                        label={translations.settingsMonthlyOrderTime}
                                        variant="outlined"
                                        value={formData.monthly_order_time}
                                        onChange={handleChange}
                                    />
                                    <TextField
                                        fullWidth
                                        margin="dense"
                                        name="weekly_order_time"
                                        label={translations.settingsWeeklyOrderTime}
                                        variant="outlined"
                                        value={formData.weekly_order_time}
                                        onChange={handleChange}
                                    />
                                </Box>
                            )}
                        </CustomTabPanel >
                    </Box>
                    <Button
                        type="button"
                        fullWidth
                        variant="contained"
                        onClick={handleSave}
                        sx={{mt: 1, mb: 1}}
                        endIcon={<SaveTwoToneIcon/>}
                        disabled={loading}
                    >
                        {loading ? (
                            <CircularProgress size={25} color="inherit"/>
                        ) : translations.save}
                    </Button>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default SettingsPage;